import { useCallback, useEffect } from 'react'

const HIDE_APPLE_LOGIN = process.env.REACT_APP_HIDE_APPLE_LOGIN

export default function AppleLoginBtn({ onSuccess }) {
    const handleSuccess = useCallback((event) => {
        onSuccess(event)
    }, [])

    useEffect(() => {
        if (HIDE_APPLE_LOGIN === 'true') {
            return
        }
        document.addEventListener('AppleIDSignInOnSuccess', handleSuccess)

        const script = document.createElement('script')

        script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/cs_CZ/appleid.auth.js'

        document.body.appendChild(script)

        return () => {
            document.removeEventListener('AppleIDSignInOnSuccess', handleSuccess)
            document.body.removeChild(script)
        }
    }, [])

    if (HIDE_APPLE_LOGIN === 'true') {
        return
    }

    return <div id="appleid-signin" style={{ height: 40, width: '100%' }} className="signin-button"></div>
}
